import Logo from './images/researchpad.png';
export let SERVER_URL = "https://test.researchpad.co/";
export const APP_NAME="ResearchPad";
export const LOGO=Logo;


